/**
 * LeadConduit API Service
 * Handles API calls to LeadConduit submit/update endpoint
 */

import axios from 'axios';

const DEFAULT_BASE_URL = process.env.NEXT_PUBLIC_LEADCONDUIT_SUBMIT_URL;

class BannerFormApiService {
  constructor() {
    this.baseUrl = DEFAULT_BASE_URL;

    this.client = axios.create({
      timeout: 10000,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });

    this.setupInterceptors();
  }

  /**
   * Setup request/response interceptors
   */
  setupInterceptors() {
    this.client.interceptors.request.use(
      (requestConfig) => {
        console.log('LeadConduit API Request:', requestConfig.url);
        return requestConfig;
      },
      (error) => Promise.reject(error),
    );

    this.client.interceptors.response.use(
      (response) => {
        console.log('LeadConduit API Response:', response.config.url, response.status);
        return response;
      },
      (error) => {
        console.error('LeadConduit API Error:', error.message);
        return Promise.reject(error);
      },
    );
  }

  /**
   * Build dynamic URL (submit/update)
   */
  buildUrl(action = 'submit') {
    if (!this.baseUrl) return '';

    let url = this.baseUrl.replace(/\/$/, '');

    // remove existing submit/update if already in env
    url = url.replace(/\/(submit|update)$/, '');

    return `${url}/${action}`;
  }

  /**
   * Submit or Update lead data
   * @param {Object} payload
   * @param {"submit" | "update"} action
   * @param {Object} options
   */
  async submitLead(payload, action = 'submit', options = {}) {
    try {
      const finalUrl = this.buildUrl(action);

      const response = await this.client.post(finalUrl, payload, options);

      return this.processResponse(response);
    } catch (error) {
      return this.handleError(error);
    }
  }

  /**
   * Process API response
   */
  processResponse(response) {
    return response.data;
  }

  /**
   * Handle API errors
   */
  handleError(error) {
    throw {
      error: true,
      message: 'LeadConduit API Error',
      details: error.message,
      status: error.response?.status || 500,
    };
  }
}

const bannerFormApiService = new BannerFormApiService();

export default bannerFormApiService;
export { BannerFormApiService };
